export default __webpack_public_path__ + "static/media/logo.e91f8342.png";